import ARProfissional from '../../views/profissional/Index.vue';
import ARPMeusDados from '../../views/profissional/MeusDados.vue';
import ARPMeuPerfil from '../../views/profissional/MeuPerfil.vue';
import ARPSolicitados from '../../views/profissional/Solicitados.vue';
import ARPRespondidas from '../../views/profissional/Respondidas.vue';
import ARPAprovadas from '../../views/profissional/Aprovadas.vue';
import ARPFinalizadas from '../../views/profissional/Finalizadas.vue';
import ARPRejeitadasPU from '../../views/profissional/RejeitadasPU.vue';
import ARPRejeitadasPL from '../../views/profissional/RejeitadasPL.vue';
import ARPCotacao from '../../views/profissional/Cotacao.vue';
import ARPRespondida from '../../views/profissional/CotacaoResposta.vue';
import ARPAprovada from '../../views/profissional/CotacaoAprovada.vue';
import ARPFinalizada from '../../views/profissional/CotacaoFinalizada.vue';
import ARPRejeitada from '../../views/profissional/CotacaoRejeitada.vue';
import ARCCheckout from '../../views/profissional/PagamentoProfissional.vue';
import ARCCheckoutPix from '../../views/profissional/qrcodepix.vue';
import ARCCheckoutPixCancel from '../../views/profissional/qrcodepixCancel.vue';
import ARCCheckoutCC from '../../views/profissional/CartaoDeCredito.vue';
import ARCCheckoutCCancel from '../../views/profissional/CartaoDeCreditoCancel.vue';
import ARCCheckoutBB from '../../views/profissional/boleto.vue';
import ARCCheckoutBBCancel from '../../views/profissional/boletoCancel.vue';
import ARCAguardandoPagamento from '../../views/profissional/AguardandoPagamento.vue';
import ARCAguardandoPagamentoPendente from '../../views/profissional/CotacaoAguardandoPagamento.vue';
import ARCAguardando from '../../views/profissional/Aguardando.vue';
import ARCAguardandoLojista from '../../views/profissional/CotacaoAguardando.vue';
import AssinaturaSite from '../../views/profissional/AssinaturaSite.vue';
import CartaoCreditoSiteAss from '../../views/profissional/CartaoCreditoSiteAss.vue';

import ProfessionalWebsiteCustomization from '../../views/profissional/website/Customization.vue';
import ProfessionalWebsiteBannerList from '../../views/profissional/website/Banner/List.vue';
import ProfessionalWebsiteBannerSave from '../../views/profissional/website/Banner/Save.vue';
import ProfessionalSocialMedias from '../../views/profissional/SocialMedias.vue';
import ARLIuguAssinatura from '../../views/profissional/ARLIuguAssinatura.vue';

import UserTypes from '../../enums/UserTypes';

export default [
  {
    path: '/area-restrita/profissional',
    name: 'profissional',
    component: ARProfissional,
    children: [
      {
        path: '/area-restrita/profissional/meus-dados',
        name: 'profissional-meus-dados',
        component: ARPMeusDados,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/minha-assinatura',
        name: 'profissional-minha-assinatura',
        component: ARLIuguAssinatura,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/meu-perfil',
        name: 'profissional-meu-perfil',
        component: ARPMeuPerfil,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/solicitados/',
        name: 'profissional-solicitados',
        component: ARPSolicitados,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area_restrita/profissional/respondidas',
        name: 'profissional-respondidas',
        component: ARPRespondidas,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/aprovadas/',
        name: 'profissional-aprovadas',
        component: ARPAprovadas,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/finalizadas/',
        name: 'profissional-finalizadas',
        component: ARPFinalizadas,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/rejeitadas-por-usuario/',
        name: 'profissional-rejeitadas-pelo-usuario',
        component: ARPRejeitadasPU,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/rejeitadas-por-lojistas/',
        name: 'profissional-rejeitadas-pelos-lojistas',
        component: ARPRejeitadasPL,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao/:id',
        name: 'profissional-cotacao',
        props: true,
        component: ARPCotacao,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao-respondida/:id/:identifier',
        name: 'profissional-cotacao-respondida',
        props: true,
        component: ARPRespondida,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao-aprovada/:id',
        name: 'profissional-cotacao-aprovada',
        props: true,
        component: ARPAprovada,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao-finalizada/:id',
        name: 'profissional-cotacao-finalizada',
        props: true,
        component: ARPFinalizada,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao-rejeitada/:cot_id/:usu_id/:tipo',
        name: 'profissional-cotacao-rejeitada',
        props: true,
        component: ARPRejeitada,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/aguardando-pagamento/',
        name: 'profissional-aguardando-pagamento',
        component: ARCAguardandoPagamento,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao-aguardando-pagamento/:id',
        name: 'profissional-cotacao-aguardando-aprovacao-pagamento',
        props: true,
        component: ARCAguardandoPagamentoPendente,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/aguardando/',
        name: 'profissional-aguardando',
        component: ARCAguardando,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao-aguardando/:id',
        name: 'profissional-cotacao-aguardando-aprovacao',
        props: true,
        component: ARCAguardandoLojista,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao/:id/pagamento/',
        name: 'profissional-cotacao-pagamento',
        props: true,
        component: ARCCheckout,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/cotacao/:id/pix/:id_shop',
        name: 'profissional-cotacao-pagamento-pix',
        props: true,
        component: ARCCheckoutPix,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/cotacao/:id/pix/cacelamento',
        name: 'profissional-cotacao-pagamento-pix-cancel',
        props: true,
        component: ARCCheckoutPixCancel,
      },
      {
        path: '/area-restrita/profissional/cotacao/:id/cc/:id_shop/:cot_id',
        name: 'profissional-cotacao-pagamento-cc',
        component: ARCCheckoutCC,
        props: true,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/cotacao/:id/cancelamento',
        name: 'profissional-cotacao-pagamento-ccancel',
        component: ARCCheckoutCCancel,
        props: true,
      },
      {
        path: '/area-restrita/profissional/cotacao/:id/bb/:id_shop',
        name: 'profissional-cotacao-pagamento-bb',
        component: ARCCheckoutBB,
        props: true,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/cotacao/:id/bb/cancelamento',
        name: 'profissional-cotacao-pagamento-bb-cancel',
        component: ARCCheckoutBBCancel,
        props: true,
      },
      {
        path: '/area-restrita/profissional/website/customizacao',
        name: 'profissional-website-customizacao',
        component: ProfessionalWebsiteCustomization,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/redes-sociais',
        name: 'profissional-website-redes-sociais',
        component: ProfessionalSocialMedias,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/website/banner',
        name: 'profissional-website-banner',
        component: ProfessionalWebsiteBannerList,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/website/banner/novo',
        name: 'profissional-website-banner-novo',
        component: ProfessionalWebsiteBannerSave,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/website/banner/:id',
        name: 'profissional-website-banner-editar',
        component: ProfessionalWebsiteBannerSave,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/assinatura-site',
        name: 'profissional-assinatura-site',
        props: true,
        component: AssinaturaSite,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
      {
        path: '/area-restrita/profissional/pagamento-assinatura-site',
        name: 'profissional-pagamento-assinatura-site',
        props: true,
        component: CartaoCreditoSiteAss,
        meta: { userType: UserTypes.PROFESSIONAL },
      },
    ],
  },
];
